//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';
// import { useLocation } from 'react-router-dom';
import SimpleBar from 'simplebar-react';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import useSimpleBarRef from '../common/hooks/useSimpleBarRef';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import TopNav from '../topNav/TopNav';
import PageMessage from '../common/elemental/PageMessage';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
    pageContainer: { backgroundColor: '#FAFAFC', overflow: 'hidden', height: '100%', minHeight: '100%', flexWrap: 'unset' },
    pageHeader: {
        maxHeight: '81px',
        // [theme.breakpoints.down('md')]: { maxHeight: '134px' }, // commented out because no more second row menu -el 20221022
        // [theme.breakpoints.down('sm')]: { maxHeight: '81px' },
    },
    pageContent: {
        flex: 1,
        overflowY: 'hidden',
    },
    tempContainer: { alignItems: 'center', marginTop: 50, paddingLeft: 16, paddingRight: 16 },
    instructionText: { marginBottom: 10 },
    email: { marginBottom: 10, maxWidth: 500 },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
    } = params;

    const defns = {
        pageContainer: { container: true, direction: 'column' },
        pageHeader: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        pageContent: { item: true, container: true },
        tempContainer: { item: true, container: true, direction: 'column' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const BlockUserLayout = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    // const appContext = useContext(AppContext);
    const context = useContext(LayoutContext);
    // const { setLoadingDialogOpen } = context;
    const { simpleBarRef: pageContentSimpleBarEl, scrollToTop: scrollToPageTop } = useSimpleBarRef();

    // const location = useLocation();
    // const subPageId = _get(location, 'state.subPageId');

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...context, scrollToPageTop }}>
            <Grid {...defns.pageContainer}>
                <Grid {...defns.pageHeader}>
                    <TopNav />
                </Grid>
                <Grid {...defns.pageContent}>
                    <SimpleBar style={{ height: '100%', width: '100%', flex: 1 }} ref={pageContentSimpleBarEl}>
                        <Grid {...defns.tempContainer}>
                            <PageMessage userNoAccess />
                        </Grid>
                    </SimpleBar>
                </Grid>
            </Grid>
        </LayoutContext.Provider>
    );
};

export default BlockUserLayout;
